import React, { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import {
  Button,
  CardActionArea,
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  CardMedia,
  CardActions,
  Box,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import {
  useAddUsedProductImageMutation,
  useGetShopifyProductImagesMutation,
  useDeleteShopifyProductImagesMutation,
  useGetShopifyProductDescriptionMutation,
  useUpdateShopifyProductDescriptionMutation,
} from "../../redux/reducer/features/Product/productSlice";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PageLoader from "../app/PageLoader";
import { Editor } from "@tinymce/tinymce-react";
import AppConfirmDialog from "../app/AppConfirmDialog";
import FileUploadIcon from "@mui/icons-material/FileUpload";
interface ProductDetailProps {
  shopifyProductId: string;
  aggregateId?: string;
  handleUpdateMatchingType: (productId: string, type: string) => void;
}
const ShopifyProductDetails: React.FunctionComponent<ProductDetailProps> = ({
  shopifyProductId,
  aggregateId,
  handleUpdateMatchingType,
}) => {
  const [productDescription, setProductDescription] = React.useState<any>(null);
  const [productImages, setProductImages] = React.useState<any[]>([]);
  const [deleteMutation, deleteMutationResult] =
    useDeleteShopifyProductImagesMutation();
  const [imageFile, setImageFile] = React.useState<File>();
  const [productImageMutation, productImageMutationResult] =
    useAddUsedProductImageMutation();
  const [productDescriptionMutation, productDescriptionMutationResult] =
    useUpdateShopifyProductDescriptionMutation();
  const [getProductImagesMutation, getProductImagesMutationResult] =
    useGetShopifyProductImagesMutation();
  const [getProductDescriptionMutation, getProductDescriptionMutationResult] =
    useGetShopifyProductDescriptionMutation();
  const [isOpen, setOpen] = React.useState(false);
  const [selectedImageId, setSelectedImageId] = React.useState("");
  const [URL, setURL] = React.useState("");
  const [Formopen, setFormOpen] = React.useState(false);
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const handleClose = () => {
    setImageFile(undefined);
    setOpen(false);
    setDeleteConfirm(false);
    setFormOpen(false);
  };

  const handleUploadClick = (e: any) => {
    var file = e.target.files[0];
    setImageFile(file);
  };

  const handleDelete = (Id: any) => {
    setDeleteConfirm(false);
    setProductImages(productImages.filter((img) => img.id !== Id));
    deleteMutation({
      aggregateId: aggregateId,
      shopifyProductId: shopifyProductId,
      shopifyImageId: Id,
    });
    if (aggregateId) handleUpdateMatchingType(aggregateId, "Custom");
  };

  const handleOnSubmit = () => {
    if (imageFile) {
      const formData = new FormData();
      formData.append("formFile", imageFile);
      formData.append("shopifyProductId", shopifyProductId);
      formData.append("aggregateId", aggregateId ?? "");
      productImageMutation({ data: formData }).then((res: any) => {
        if (res && res.data.status === 200) {
          handleClose();
          getProductImages();
          handleUpdateMatchingType(aggregateId ?? "", "Custom");
        }
      });
    } else {
      console.log("File not Selected");
    }
  };

  useEffect(() => {
    getProductDescription();
  }, []);

  const getProductImages = () => {
    getProductImagesMutation({ productId: shopifyProductId }).then(
      (res: any) => {
        if (res && res.data.status === 200) {
          setProductImages(res.data.entityList);
        }
      }
    );
  };
  const getProductDescription = () => {
    getProductDescriptionMutation({ productId: shopifyProductId }).then(
      (res: any) => {
        if (res && res.data.status === 200) {
          setProductDescription(res.data.entity);
          setProductImages(res.data.entity?.images);
        }
      }
    );
  };
  const handlUpdateProductDescription = (description: string) => {
    productDescriptionMutation({
      aggregateId: aggregateId,
      shopifyProductId: shopifyProductId,
      description: description,
    }).then((res: any) => {
      if (res && res.data.status === 200) {
        handleUpdateMatchingType(aggregateId ?? "", "Custom");
      }
    });
  };

  return (
    <>
      <PageLoader
        isLoading={
          getProductImagesMutationResult.isLoading ||
          productImageMutationResult.isLoading ||
          productDescriptionMutationResult.isLoading ||
          getProductDescriptionMutationResult.isLoading
        }
      />
      <Box>
        <Editor
          apiKey="x605s4ekb74hvf848w5gdxgxmjspqtbadveijod91dcezrsm"
          init={{
            plugins: [
              "save",
              "undo",
              "redo",
              "blocks",
              "fontfamily",
              "fontsize",
              "bold",
              "italic",
              "underline",
              "strikethrough",
              "link",
              "image",
              "media",
              "table",
              "mergetags",
              "align",
              "lineheight",
              "lists",
              "checklist",
              "numlist",
              "bullist",
              "indent",
              "outdent",
              "removeformat",
            ],
            toolbar:
              "customsavebutton | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | align lineheight | checklist numlist bullist indent outdent | removeformat",
            tinycomments_mode: "embedded",
            branding: false,
            menubar: false,
            automatic_uploads: true,
            forced_root_block: "",
            paste_remove_styles: true,
            paste_remove_spans: true,
            setup: (editor: any) => {
              editor.ui.registry.addButton("customsavebutton", {
                text: "Save",
                onAction: () =>
                  handlUpdateProductDescription(editor.getContent()),
                tooltip: "Save Content",
              });
            },
          }}
          initialValue={productDescription?.bodyHtml ?? ""}
        />
      </Box>
      <Grid mt={2} container spacing={2} width="xl">
        {productImages && productImages.length > 0
          ? productImages.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={3}
                className="list-container"
                key={item.id}
              >
                <Card sx={{ maxWidth: 345 }}>
                  <CardActionArea>
                    <CardMedia
                      component="img"
                      height="200"
                      image={item.src}
                      alt="green iguana"
                      onClick={() => {
                        setOpen(true);
                        setURL(item.src);
                      }}
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="div"
                      ></Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <DeleteForeverIcon
                      sx={{ color: "red", cursor: "pointer" }}
                      onClick={() => {
                        setDeleteConfirm(true);
                        setSelectedImageId(item.id ?? "");
                      }}
                    />
                  </CardActions>
                </Card>
              </Grid>
            ))
          : ""}

        <Grid item xs={12} sm={3}>
          <Card
            sx={{ height: "280px" }}
            onClick={() => {
              setFormOpen(true);
            }}
          >
            <CardActionArea
              sx={{
                textAlign: "center",
                paddingTop: 14,
                paddingBottom: 13.5,
                color: "#8392ab",
              }}
            >
              <CardContent>
                <AddIcon />
                <Typography gutterBottom variant="h5" component="div">
                  New Image
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
      <Dialog open={Formopen} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle alignSelf={"center"}>Add Image</DialogTitle>
        <DialogContent sx={{ mt: 2, mb: 2 }}>
          <Box
            display={"flex"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            gap={4}
          >
            <Button
              sx={{ backgroundColor: "#f0f0f0", color: "black", width: "40%" }}
              variant="contained"
              component="label"
              endIcon={<FileUploadIcon />}
            >
              Choose Image
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={handleUploadClick}
              />
            </Button>
            <Typography
              fontSize={"small"}
              sx={{ fontStyle: "italic", color: imageFile ? "black" : "red" }}
            >
              {imageFile ? imageFile.name : "*No File Selected"}{" "}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={productImageMutationResult.isLoading}
            onClick={handleOnSubmit}
            endIcon={
              productImageMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {isOpen && <Lightbox mainSrc={URL} onCloseRequest={handleClose} />}
      <AppConfirmDialog
        headerText="Confirm to Delete"
        bodyText="Are you sure to delete this Image?"
        onFail={() => {
          setDeleteConfirm(false);
        }}
        onSuccess={() => {
          if (selectedImageId) handleDelete(selectedImageId);
        }}
        handleClose={() => {
          setDeleteConfirm(false);
        }}
        isOpen={deleteConfirm}
      />
    </>
  );
};

export default ShopifyProductDetails;
